import NanoModal from "./modal";

export default function updateFavouritesModal() {
  const isPresent = document.querySelector("#fav-modal");
  if (!isPresent) return;

  const modal = document.querySelector("#fav-modal");
  const modalContent = modal.querySelector("[data-fav-offers-content]");
  const favouritesCountElement = modal.querySelector(".favourites-count");
  const removeAllButton = modal.querySelector(".remove-all-favourites");
  let favCount = 0;

  async function fetchFavourites() {
    try {
      const response = await fetch("/wp-json/estravel/v1/get_fav_offers", {
        method: "GET",
      });
      if (response.ok) {
        const data = await response.json();
        favCount = data.count;
        modalContent.innerHTML = data.html || "<p>No favourites found</p>";
        updateFavouriteCount();
        attachFavouriteListeners();
      } else {
        console.error("Error fetching favourites");
      }
    } catch (error) {
      console.error("Request failed", error);
    }
  }

  async function removeAllFavourites() {
    console.log("Starting removeAllFavourites");
    try {
      const response = await fetch(
        "/wp-json/estravel/v1/remove_all_fav_offers",
        {
          method: "POST",
        }
      );
      if (response.ok) {
        modalContent.innerHTML = "";
        favCount = 0;
        updateFavouriteCount();
        document
          .querySelectorAll("[data-add-offer-to-favourites]")
          .forEach((button) => button.classList.remove("active-favourite"));
        console.log("All favourites removed");
      } else {
        console.error("Error removing all favourites");
      }
    } catch (error) {
      console.error("Request failed", error);
    }
  }

  function attachFavouriteListeners() {
    document
      .querySelectorAll("[data-add-offer-to-favourites]")
      .forEach((button) => {
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener("click", async function () {
          const offer_id = this.getAttribute("data-offer-id");
          const buttonElement = this;
          const offerCard = buttonElement.closest("#fav-modal li");

          try {
            const response = await fetch(
              "/wp-json/estravel/v1/toggle_fav_offer",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ offer_id }),
              }
            );

            if (response.ok) {
              if (buttonElement.classList.contains("active-favourite")) {
                buttonElement.classList.remove("active-favourite");
                if (offerCard) offerCard.remove();
                removeActiveFavouriteClass(offer_id);
                favCount = Math.max(0, favCount - 1);
              } else {
                buttonElement.classList.add("active-favourite");
                favCount += 1;
              }
              updateFavouriteCount();
            } else {
              console.error("Error processing request");
            }
          } catch (error) {
            console.error("Request failed", error);
          }
        });
      });
  }

  function removeActiveFavouriteClass(offer_id) {
    document
      .querySelectorAll(`[data-offer-id='${offer_id}']`)
      .forEach((button) => {
        button.classList.remove("active-favourite");
      });
  }

  function updateFavouriteCount() {
    favouritesCountElement.innerHTML = `<strong>${favCount}</strong> ${
      favCount === 1 ? wpGlobals.fav_string : wpGlobals.favs_string
    }`;

    if (favCount === 0) {
      removeAllButton.classList.add("hidden");
    } else {
      removeAllButton.classList.remove("hidden");
    }
  }

  if (removeAllButton) {
    removeAllButton.addEventListener("click", removeAllFavourites);
  }

  attachFavouriteListeners();

  document.addEventListener("facetwp-loaded", attachFavouriteListeners);

  document.addEventListener("click", (e) => {
    if (!e.target.classList.contains("open-fav-modal")) return;

    const modalTrigger = e.target;
    const modal = new NanoModal("#fav-modal", {
      onShow: () => {
        modalTrigger.setAttribute("aria-expanded", "true");
        modalTrigger.classList.add("modal-trigger-open");
        fetchFavourites();
      },
      onClose: () => {
        modalTrigger.setAttribute("aria-expanded", "false");
        modalTrigger.classList.remove("modal-trigger-open");
      },
      closeOnEscape: true,
      closeOnOutsideClick: true,
      disableScrollShift: true,
      disableScroll: true,
      debug: false,
    });

    modal.showModal();
  });
}
